<template>
  <transition name="targeting-button">
    <div v-if="visible"
         class="targeting-button"
         :class="{
           'disabled': disabled
         }">
      <button type="button"
              @click="onTargetingButtonClick">
        <i :class="`icon icon--targeting${ !disabled ? '-animated' : ' disabled'}`"></i>
        <span class="text">{{ 'Targeting Journey' }}</span>
      </button>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { JOURNEY_TARGETING_VIEWABLE_START_DATE } from '@/store'
import { create } from 'vue-modal-dialogs'
import AppDialog from '@/components/ui/AppDialog.vue'
import { isInIframe } from '@/libs/auth-helper'

const openDialog = create(AppDialog)

export default {
  name: 'NodeReportTargetingButton',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isTracking: {
      type: Boolean,
      required: false,
      default: false
    },
    gUrlId: {
      type: Number,
      required: true
    },
    nodeData: {
      type: Object,
      required: true
    },
    isCustomNode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState([
      'journeyOptions',
      'journeyPeriod',
      'journeyTargetingOptions'
    ]),
    journeyTargetingViewableStartTime () {
      return new Date(JOURNEY_TARGETING_VIEWABLE_START_DATE).getTime()
    },
    isUnableToTarget () {
      return this.journeyTargetingViewableStartTime > new Date(this.journeyPeriod.end).getTime()
    }
  },
  watch: {
  },
  created () {
  },
  methods: {
    ...mapMutations([
      'setJourneyTargetingOptions',
      'setJourneyOptions'
    ]),

    async onTargetingButtonClick () {
      if (this.isTracking) {
        const confirmed = await openDialog({
          dialogType: 'tracking.stopTrackingWithDesc',
          optionContent: { style: 'height: 14px;' }
        })
        if (!confirmed) return
      }

      if (this.journeyTargetingViewableStartTime > new Date(this.journeyPeriod.start).getTime()) {
        this.setJourneyTargetingOptions('start-date-is-not-viewable')
      } else {
        const currentPage = this.$route.name

        let targetNodeKey = this.isCustomNode ? this.gUrlId : null
        if (this.journeyOptions.matchType === 'exact') {
          targetNodeKey = this.nodeData.url
        }

        if (currentPage !== 'journey') {
          const newWindow = window.open(location.href.replace(/\/tool\/[^?]+\?/, '/tool/journey?'), isInIframe() ? '_self' : '_blank')
          newWindow._journeyOptionsFromParent = { ...this.journeyOptions }
          newWindow._journeyPeriodFromParent = { ...this.journeyPeriod }
          newWindow._journeyTargetingOptionsFromParent = {
            direction: 'backward',
            gUrlId: this.gUrlId,
            nodeData: this.nodeData,
            pageFrom: currentPage,
            isCustomNode: this.isCustomNode,
            targetNodeKey
          }
        } else {
          const targetData = {
            pageFrom: currentPage,
            gUrlId: this.gUrlId,
            nodeData: this.nodeData,
            isCustomNode: this.isCustomNode,
            targetNodeKey
          }

          console.log(targetData)

          // this.setJourneyTargetingOptions({
          //   pageFrom: currentPage,
          //   gUrlId: this.gUrlId,
          //   nodeData: this.nodeData
          // })

          this.setJourneyTargetingOptions(targetData)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.targeting-button {
  position: relative;
  height: calc(36px + 12px);

  &-enter-active {
    transition: height 0.3s $ease-out-quart, opacity 0.25s 0.15s ease-out;
  }
  &-leave-active {
    overflow: hidden;
    transition: height 0.3s 0.05s $ease-out-quart, opacity 0.1s ease-out;
  }
  &-enter, &-leave-to {
    height: 0;
    opacity: 0;
  }

  &.disabled {
    button {
      pointer-events: none;

      & span.text {
        opacity: 0.2;
      }

      &:before {
        content: none;
      }

      & .icon--targeting {
        opacity: 0.2;
      }
    }
  }

  button {
    position: relative;
    width: 100%;
    height: 36px;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    line-height: 36px;
    padding-right: 10px;
    border-radius: 6px;
    background-color: #fff;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 3px 4px -2px rgba(0, 0, 0, 0.25);
    overflow: hidden;
    transform: translateY(12px);

    &:before {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      content: '';
      background-color: rgba(0, 0, 0, 0.06);
      opacity: 0;
      transition: opacity 0.15s ease-out;
    }

    &:hover:before {
      opacity: 1;
    }

    i.icon {
      position: relative;
      width: 24px;
      height: 36px;
      vertical-align: top;
      display: inline-block;
    }
  }

  .disabled-info {
    position: absolute;
    right: 0;
    top: 12px;
    cursor: pointer;

    &:hover .bubble {
      opacity: 1;
      transform: translate(0, 0);
    }

    .icon {
      width: 36px;
      height: 36px;
      background-size: 18px;
    }

    .bubble {
      right: 0;
      bottom: calc(100% + 0px);
      padding-left: 20px;
      padding-right: 20px;
      transform: translate(0, 10px);
      opacity: 0;
      pointer-events: none;
      transition: transform 0.2s ease, opacity 0.2s ease;

      & /deep/ {
        .text {
          text-align: left;
        }
        .arrow {
          left: auto;
          right: 9px;
        }
      }
    }
  }
}
</style>
